const aiChatToolbarStyles = {
  statusCircle: {
    display: "inline-block",
    height: ".5rem",
    width: ".5rem",
    borderRadius: "50%",
    backgroundColor: "success.main",
    marginRight: ".5rem",
  },
};

export default aiChatToolbarStyles;
